export default __webpack_public_path__ + "static/media/img_blanketBaseBunny_grey.62aadb3a.jpg";